import { useRouter } from 'next/router';
import { useEffect } from 'react';

export function GeoRedirect() {
  const router = useRouter();

  useEffect(() => {
    // Only detect country for calendar selection, don't redirect language
    if (typeof window === 'undefined') return;

    const hasDetectedCountry = sessionStorage.getItem('detected_country');

    // Skip if we've already detected country
    if (hasDetectedCountry) return;

    // Detect country and store it
    async function detectCountry() {
      try {
        let country = null;

        // Try IP geolocation service
        try {
          const response = await fetch('https://ipapi.co/json/');
          const data = await response.json();
          country = data.country_code;
          console.log('Detected country from IP:', country);

          // FOR TESTING: Uncomment one of these to force specific country
          // country = 'PT'; // Test Portugal
          // country = 'BR'; // Test Brazil
          // country = 'AU'; // Test Australia
        } catch (e) {
          console.log('IP geolocation failed');
        }

        // Store detected country for calendar selection (don't redirect)
        if (country) {
          sessionStorage.setItem('detected_country', country);
          console.log(`Country detected: ${country} (language stays English)`);
        }
      } catch (error) {
        console.log('Geo-detection failed:', error);
      }
    }

    // Run detection after a short delay to avoid blocking initial render
    const timer = setTimeout(detectCountry, 1000);

    return () => clearTimeout(timer);
  }, [router]);

  return null; // This component doesn't render anything
}